import api from "../api";

export const UPDATE_TRANSLATION_SUCCESS ='UPDATE_TRANSLATION_SUCCESS';
export const UPDATE_TRANSLATION_FAILURE ='UPDATE_TRANSLATION_FAILURE';
export const GET_TRANSLATION_SUCCESS ='GET_TRANSLATION_SUCCESS';

//Actions
export const updateTranslationSuccess=(value)=>{
    return {
        type: UPDATE_TRANSLATION_SUCCESS,
        payload: value
    }
}

export const getTranslationSuccess=(value)=>{
    return {
        type: GET_TRANSLATION_SUCCESS,
        payload: value
    }
}

export const updateTranslationFailure=(value)=>{
    return {
        type: UPDATE_TRANSLATION_FAILURE,
        payload: value
    }
}

export const updateTranslation=(row, callBack)=>{
    document.body.className='loading';
    return (dispach)=>{
        api.put("/Translations/update",row)
        .then(response=>{
            //console.log(response.data);
            dispach(updateTranslationSuccess(response.data));
            if (callBack!==undefined){
                callBack(response.data,null);
            }
            document.body.className='';
        }).catch(error=>{
            //console.log(error);
            dispach(updateTranslationFailure(error));
            if (callBack!==undefined){
                callBack(null,error);
            }
            document.body.className='';
        });
    }
}


export default updateTranslation;